import axios from 'axios'
import { EspdRequest } from './espd-requests'

// Fetch the ESPD request from the server by id
export async function getPublicRequest(
  uuid: string,
  publicServiceUrl: string,
): Promise<EspdRequest | undefined> {
  const url = `${publicServiceUrl}requests/${uuid}`
  try {
    const returned = await axios.get(url)
    return returned.data as EspdRequest
  } catch (error) {
    return undefined
  }
}

export async function getPublicRequestXml(
  uuid: string,
  publicServiceUrl: string,
): Promise<string | undefined> {
  const url = `${publicServiceUrl}requests/${uuid}/xml`
  try {
    const returned = await axios.get(url)
    return returned.data as string
  } catch (error) {
    return undefined
  }
}

export async function getResponseXml(
  id: string,
  publicServiceUrl: string,
): Promise<string | undefined> {
  const url = `${publicServiceUrl}responses/${id}/xml`
  try {
    const returned = await axios.get(url)
    return returned.data as string
  } catch (error) {
    return undefined
  }
}
